;(function(){
	if (!$("body").hasClass("page-template-template-contact")) return;

	console.log("contact.js")

	$('#adac_map').show(); 
	$('#adac_west_map').hide();

	$("a.show_adac_map").on("click", function(){
		$('#adac_map').show(); 
		$('#adac_west_map').hide();
	})

	$("a.show_adac_west_map").on("click", function(){
		$('#adac_map').hide(); 
		$('#adac_west_map').show();
	})
})();